import { Supplier } from "../my-type";
import { authUserData } from ".";
import {
  SupplierService as GeneratedSupplierService,
  callApi,
  configureApiClient,
} from "../api/client";

const configureSupplierApiClient = () => {
  configureApiClient({
    tokenProvider: () => authUserData()?.jwtToken ?? null,
  });
};

const mapSupplier = (value: unknown): Supplier => {
  const supplier = value as Supplier;
  return {
    ...supplier,
    createdAt: new Date((supplier as { createdAt?: string | Date }).createdAt ?? Date.now()),
  };
};

/**
 * Get all suppliers associated with a specific team
 * @param teamId The team's unique identifier
 * @returns Array of Supplier objects or null if error
 */
export const getSuppliersByTeamId = async (teamId: number): Promise<Supplier[] | null> => {
  try {
    configureSupplierApiClient();
    const data = await callApi(
      () => GeneratedSupplierService.getApiSupplierTeam(teamId),
      "Failed to fetch suppliers by team"
    );
    return (data as unknown[]).map(mapSupplier);
  } catch (error) {
    console.error("Error fetching suppliers by team ID:", error);
    return null;
  }
};

/**
 * Get a specific supplier by ID
 * @param supplierId The supplier's unique identifier
 * @returns Supplier object or null if error
 */
export const getSupplierById = async (supplierId: number): Promise<Supplier | null> => {
  try {
    configureSupplierApiClient();
    const data = await callApi(
      () => GeneratedSupplierService.getApiSupplier(supplierId),
      "Failed to fetch supplier"
    );
    return mapSupplier(data);
  } catch (error) {
    console.error("Error fetching supplier by ID:", error);
    return null;
  }
};
